var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBWidgets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-widgets",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-widgets1",
    serifid: "iconB-widgets"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.075,2c1.062,0.001 1.924,0.862 1.925,1.925l-0,5.15c-0.001,1.063 -0.862,1.924 -1.925,1.925l-5.15,-0c-1.063,-0.001 -1.924,-0.862 -1.925,-1.925l0,-5.15c0.001,-1.063 0.862,-1.924 1.925,-1.925l5.15,0Zm-5.075,7l5,-0l-0,-5l-5,-0l-0,5Zm16.075,4c1.062,0.001 1.924,0.862 1.925,1.925l-0,5.15c-0.001,1.063 -0.862,1.924 -1.925,1.925l-5.15,-0c-1.063,-0.001 -1.924,-0.862 -1.925,-1.925l0,-5.15c0.001,-1.063 0.862,-1.924 1.925,-1.925l5.15,0Zm-5.075,7l5,-0l-0,-5l-5,-0l-0,5Zm3.227,-17.545l3.682,7.321c0.131,0.26 0.12,0.571 -0.028,0.821c-0.149,0.25 -0.414,0.403 -0.699,0.403l-7.364,-0c-0.285,0 -0.55,-0.153 -0.699,-0.403c-0.148,-0.25 -0.159,-0.561 -0.028,-0.821l3.682,-7.321c0.14,-0.28 0.421,-0.455 0.727,-0.455c0.306,0 0.587,0.175 0.727,0.455Zm-11.727,10.545c2.484,-0 4.5,2.016 4.5,4.5c0,2.484 -2.016,4.5 -4.5,4.5c-2.484,-0 -4.5,-2.016 -4.5,-4.5c0,-2.484 2.016,-4.5 4.5,-4.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBWidgets);
export default __webpack_public_path__ + "static/media/iconB-widgets.fa61687eeffc3ec5bcc2007ca3c94483.svg";
export { ForwardRef as ReactComponent };